import { createEntityReducer } from 'ext/lib/collections';
import { TYPE } from './actions';

export default createEntityReducer(TYPE);

export const selectRedirecting = state => state[TYPE]?.redirecting;
export const selectSpoofing = state => state[TYPE]?.spoofing;
